'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { RecomendacoesMetrics } from '../types/analytics.types';
import { Lightbulb, Clock, DollarSign, AlertTriangle, Info, Zap, ArrowRight, TrendingUp } from 'lucide-react';
interface RecomendacoesListProps {
  data: RecomendacoesMetrics;
}
export const RecomendacoesList: React.FC<RecomendacoesListProps> = t0 => {
  const $ = _c(50);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-3"><div className="from-chart-warning to-chart-warning-light flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br shadow-md"><Zap className="h-5 w-5 text-white" /></div><h3 className="text-xl font-bold text-neutral-900">Recomendações da IA</h3></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-4 flex items-center gap-3"><div className="from-chart-primary to-chart-secondary ring-chart-primary/10 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br shadow-md ring-4"><Clock className="h-6 w-6 text-white" /></div><h4 className="text-chart-primary text-lg font-bold">Melhor Horário</h4></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data.melhorHorarioEnvio.periodo) {
    t3 = <p className="mb-2 text-2xl font-extrabold text-neutral-900">{data.melhorHorarioEnvio.periodo}</p>;
    $[2] = data.melhorHorarioEnvio.periodo;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== data.melhorHorarioEnvio.diaSemana) {
    t4 = data.melhorHorarioEnvio.diaSemana.join(" e ");
    $[4] = data.melhorHorarioEnvio.diaSemana;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <p className="mb-3 text-base font-medium text-neutral-700">{t4}</p>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== data.melhorHorarioEnvio.fundamentacao) {
    t6 = <p className="text-sm leading-relaxed text-neutral-500">{data.melhorHorarioEnvio.fundamentacao}</p>;
    $[8] = data.melhorHorarioEnvio.fundamentacao;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className="rounded-2xl border border-neutral-100 bg-white p-6 shadow-sm">{t2}{t3}{t5}{t6}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-4 flex items-center gap-3"><div className="from-chart-secondary to-chart-accent ring-chart-secondary/10 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br shadow-md ring-4"><DollarSign className="h-6 w-6 text-white" /></div><h4 className="text-chart-secondary text-lg font-bold">Faixa Ideal</h4></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== data.faixaValorOtima.max || $[16] !== data.faixaValorOtima.min) {
    t9 = <p className="mb-3 text-2xl font-extrabold text-neutral-900">R$ {data.faixaValorOtima.min} - {data.faixaValorOtima.max}</p>;
    $[15] = data.faixaValorOtima.max;
    $[16] = data.faixaValorOtima.min;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <TrendingUp className="text-chart-secondary h-4 w-4" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== data.faixaValorOtima.taxaSucessoEsperada) {
    t11 = <div className="from-chart-secondary/10 to-chart-accent/10 ring-chart-secondary/20 mb-3 inline-flex items-center gap-2 rounded-full bg-gradient-to-r px-3 py-1.5 ring-1">{t10}<span className="text-chart-secondary text-sm font-bold">{data.faixaValorOtima.taxaSucessoEsperada}% conversão esperada</span></div>;
    $[19] = data.faixaValorOtima.taxaSucessoEsperada;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== data.faixaValorOtima.fundamentacao) {
    t12 = <p className="text-sm leading-relaxed text-neutral-500">{data.faixaValorOtima.fundamentacao}</p>;
    $[21] = data.faixaValorOtima.fundamentacao;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t9) {
    t13 = <div className="rounded-2xl border border-neutral-100 bg-white p-6 shadow-sm">{t8}{t9}{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mb-4 flex items-center gap-3"><div className="from-chart-warning to-chart-warning-light ring-chart-warning/10 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br shadow-md ring-4"><Lightbulb className="h-6 w-6 text-white" /></div><h4 className="text-chart-warning text-lg font-bold">Estratégia Vencedora</h4></div>;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== data.estrategiasEfetivas[0].estrategia) {
    t15 = <p className="mb-3 line-clamp-2 text-xl leading-snug font-bold text-neutral-900">{data.estrategiasEfetivas[0].estrategia}</p>;
    $[28] = data.estrategiasEfetivas[0].estrategia;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <TrendingUp className="text-chart-warning h-4 w-4" />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== data.estrategiasEfetivas[0].resultadoMedio) {
    t17 = <div className="from-chart-warning/10 to-chart-warning-light/10 ring-chart-warning/20 mb-3 inline-flex items-center gap-2 rounded-full bg-gradient-to-r px-3 py-1.5 ring-1">{t16}<span className="text-chart-warning text-sm font-bold">{data.estrategiasEfetivas[0].resultadoMedio}% de sucesso</span></div>;
    $[31] = data.estrategiasEfetivas[0].resultadoMedio;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== data.estrategiasEfetivas[0].quantidadeTestes) {
    t18 = <p className="text-sm leading-relaxed text-neutral-500">Baseado em {data.estrategiasEfetivas[0].quantidadeTestes} testes realizados</p>;
    $[33] = data.estrategiasEfetivas[0].quantidadeTestes;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t15 || $[36] !== t17 || $[37] !== t18) {
    t19 = <div className="rounded-2xl border border-neutral-100 bg-white p-6 shadow-sm">{t14}{t15}{t17}{t18}</div>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t13 || $[40] !== t19 || $[41] !== t7) {
    t20 = <div className="grid grid-cols-1 gap-5">{t7}{t13}{t19}</div>;
    $[39] = t13;
    $[40] = t19;
    $[41] = t7;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== data.alertas) {
    t21 = data.alertas.map(_temp);
    $[43] = data.alertas;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t21) {
    t22 = <div className="space-y-4">{t21}</div>;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t20 || $[48] !== t22) {
    t23 = <div className="space-y-6">{t1}{t20}{t22}</div>;
    $[47] = t20;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  return t23;
};
function _temp(alerta, index) {
  return <div key={index} className={`group flex items-start gap-4 rounded-xl border-2 p-5 shadow-sm transition-all duration-300 hover:shadow-md ${alerta.tipo === "warning" ? "border-amber-200 bg-gradient-to-br from-amber-50 to-amber-100/50 text-amber-900 hover:border-amber-300" : alerta.tipo === "info" ? "border-blue-200 bg-gradient-to-br from-blue-50 to-blue-100/50 text-blue-900 hover:border-blue-300" : "border-neutral-200 bg-gradient-to-br from-neutral-50 to-neutral-100/50 hover:border-neutral-300"}`}><div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg shadow-sm ${alerta.tipo === "warning" ? "bg-gradient-to-br from-amber-400 to-amber-500" : "bg-gradient-to-br from-blue-400 to-blue-500"}`}>{alerta.tipo === "warning" ? <AlertTriangle className="h-5 w-5 text-white" /> : <Info className="h-5 w-5 text-white" />}</div><div className="min-w-0 flex-1"><h5 className="mb-1 text-base font-bold">{alerta.titulo}</h5><p className="text-sm leading-relaxed opacity-90">{alerta.mensagem}</p></div><button className={`flex shrink-0 items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold whitespace-nowrap shadow-sm transition-all duration-300 hover:gap-3 hover:shadow-md ${alerta.tipo === "warning" ? "bg-white text-amber-900 ring-1 ring-amber-200 hover:bg-amber-50" : "bg-white text-blue-900 ring-1 ring-blue-200 hover:bg-blue-50"}`}>{alerta.acao}<ArrowRight className="h-4 w-4" /></button></div>;
}